const { gql } = require("@apollo/client");

// * package

const PACKAGE_LIST_FIELDS = gql`
  fragment PackageListFields on SamplePackageType {
    id
    destination {
      id
      shortName
      streetAddress
      streetAddress2
      cityPostal
      country
      countryName
    }
    status
    trackingNumber
    cost
    method
    createdAt
    creator {
      id
      email
      firstName
      lastName
    }
    isMatched
    images {
      id
      name
      url
    }
    items {
      cc {
        id
        username
        email
      }
    }
    checkItems {
      senders {
        id
        username
        email
      }
      receivers {
        id
        username
        email
      }
    }
  }
`;

export const FETCH_PACKAGES = gql`
  ${PACKAGE_LIST_FIELDS}
  query FETCH_PACKAGES($limit: Int, $offset: Int, $q: String) {
    packages(limit: $limit, offset: $offset, q: $q) {
      total
      results {
        ...PackageListFields
      }
    }
  }
`;

export const FETCH_ALL_PACKAGES = gql`
  ${PACKAGE_LIST_FIELDS}
  query FETCH_ALL_PACKAGES {
    allPackages {
      ...PackageListFields
    }
  }
`;

export const CREATE_PACKAGE = gql`
  mutation CREATE_PACKAGE($destinationId: Int!) {
    createPackage(destinationId: $destinationId) {
      package {
        id
        destination {
          id
          shortName
          streetAddress
          streetAddress2
          cityPostal
          country
          countryName
        }
        status
        trackingNumber
        method
        createdAt
        creator {
          id
          email
        }
        items {
          id
        }
      }
    }
  }
`;

export const UPDATE_PACKAGE = gql`
  mutation UPDATE_PACKAGE($id: Int!, $destinationId: Int!) {
    updatePackage(id: $id, destinationId: $destinationId) {
      package {
        id
        destination {
          id
          shortName
          streetAddress
          streetAddress2
          cityPostal
          country
          countryName
        }
        status
        trackingNumber
        cost
        createdAt
      }
    }
  }
`;

export const UPDATE_PACKAGE_CC = gql`
  mutation UPDATE_PACKAGE_CC($id: Int!, $ccs: [Int!]) {
    updatePackageCc(id: $id, ccs: $ccs) {
      package {
        id
        cc {
          id
          username
          email
        }
      }
    }
  }
`;

export const SEND_PACKAGE_EMAIL = gql`
  mutation SEND_PACKAGE_EMAIL($id: Int!) {
    sendPackageEmail(id: $id) {
      isSuccess
    }
  }
`;

export const DELETE_PACKAGE = gql`
  mutation DELETE_PACKAGE($id: Int!) {
    deletePackage(id: $id) {
      success
    }
  }
`;

export const FETCH_PACKAGE_INFO = gql`
  query FETCH_PACKAGE_INFO($id: Int!) {
    packageInfo(id: $id) {
      id
      status
      destination {
        id
        shortName
        company
        attention
        email
        phone
        streetAddress
        streetAddress2
        cityPostal
        country
        countryName
      }
      cost
      cartonQty
      trackingNumber
      method
      cc {
        id
        username
        email
      }
      createdAt
      hasNotifiedAll
    }
    allSamples(packageId: $id) {
      id
      name
      nameCn
      quantity
      material
      materialMark
      serviceType
      cc {
        id
        username
        email
      }
      unit
      hsCode
      price
      checkItems {
        id
        content
        sample {
          id
        }
        package {
          id
        }
        senders {
          id
          username
          email
        }
        receivers {
          id
          username
          email
        }
      }
    }
    allPackageImagesByPkgId(packageId: $id) {
      id
      name
      url
    }
    allInternalUsers {
      id
      username
      email
    }
    allPtToolSenders {
      id
      username
      email
    }
  }
`;

export const FETCH_INTERNAL_USERS = gql`
  query FETCH_INTERNAL_USERS {
    allInternalUsers {
      id
      username
      email
    }
  }
`;

// * sample

export const CREATE_SAMPLE = gql`
  mutation CREATE_SAMPLE(
    $name: String!
    $nameCn: String!
    $quantity: Int!
    $packageId: Int!
    $unit: String
    $material: String
    $materialMark: String
    $serviceType: String
    $hsCode: String
    $price: Float
    $messages: [SampleMessageInputType]
  ) {
    createSample(
      name: $name
      nameCn: $nameCn
      quantity: $quantity
      packageId: $packageId
      unit: $unit
      material: $material
      materialMark: $materialMark
      serviceType: $serviceType
      hsCode: $hsCode
      price: $price
      messages: $messages
    ) {
      sample {
        id
        name
        nameCn
        quantity
        unit
        material
        materialMark
        serviceType
      }
    }
  }
`;

export const DELETE_SAMPLE = gql`
  mutation DELETE_SAMPLE($sampleId: Int!) {
    deleteSample(sampleId: $sampleId) {
      success
    }
  }
`;

export const UPDATE_SAMPLE = gql`
  mutation UPDATE_SAMPLE(
    $sampleId: Int!
    $name: String!
    $nameCn: String!
    $quantity: Int!
    $unit: String
    $material: String
    $materialMark: String
    $serviceType: String
    $hsCode: String
    $price: Float
    $messages: [SampleMessageInputType]
  ) {
    updateSample(
      sampleId: $sampleId
      name: $name
      nameCn: $nameCn
      quantity: $quantity
      unit: $unit
      material: $material
      materialMark: $materialMark
      serviceType: $serviceType
      hsCode: $hsCode
      price: $price
      messages: $messages
    ) {
      sample {
        id
        name
        nameCn
        quantity
        unit
        material
        materialMark
        serviceType
        hsCode
        price
      }
    }
  }
`;

// * package image

export const CREATE_PACKAGE_IMAGE = gql`
  mutation CREATE_PACKAGE_IMAGE(
    $url: String!
    $packageId: Int!
    $name: String
  ) {
    createPackageImage(url: $url, packageId: $packageId, name: $name) {
      packageImage {
        id
        name
        url
      }
    }
  }
`;

export const DELETE_PACKAGE_IMAGE = gql`
  mutation DELETE_PACKAGE_IMAGE($imageId: Int!) {
    deletePackageImage(imageId: $imageId) {
      success
    }
  }
`;

// * check item

export const FETCH_ALL_CHECK_ITEMS_BY_SAMPLE_ID = gql`
  query FETCH_ALL_CHECK_ITEMS_BY_SAMPLE_ID($sampleId: Int!) {
    allCheckItemsBySampleId(sampleId: $sampleId) {
      id
      content
      sample {
        id
      }
      package {
        id
      }
      senders {
        id
        username
        email
      }
      receivers {
        id
        username
        email
      }
    }
  }
`;

export const CREATE_CHECK_ITEM = gql`
  mutation CREATE_CHECK_ITEM(
    $content: String
    $sampleId: Int!
    $packageId: Int!
    $isChecked: Boolean
    $senders: [Int!]
    $receivers: [Int!]
  ) {
    createCheckItem(
      content: $content
      sampleId: $sampleId
      packageId: $packageId
      isChecked: $isChecked
      senders: $senders
      receivers: $receivers
    ) {
      checkItem {
        id
        content
        sample {
          id
        }
        package {
          id
        }
        senders {
          id
          username
          email
        }
        receivers {
          id
          username
          email
        }
      }
    }
  }
`;

export const DELETE_CHECK_ITEM = gql`
  mutation DELETE_CHECK_ITEM($itemId: Int!) {
    deleteCheckItem(itemId: $itemId) {
      success
    }
  }
`;

export const UPDATE_CHECK_ITEM = gql`
  mutation UPDATE_CHECK_ITEM(
    $itemId: Int!
    $content: String!
    $isChecked: Boolean
  ) {
    updateCheckItem(itemId: $itemId, content: $content, isChecked: $isChecked) {
      checkItem {
        id
        content
        sample {
          id
        }
        package {
          id
        }
      }
    }
  }
`;

// * package address

export const FETCH_ALL_PACKAGE_ADDRESSES = gql`
  query FETCH_ALL_PACKAGE_ADDRESSES {
    allPackageAddresses {
      id
      shortName
      company
      attention
      email
      phone
      streetAddress
      streetAddress2
      cityPostal
      country
      countryName
    }
  }
`;

export const FETCH_ALL_PACKAGE_COUNTRIES = gql`
  query FETCH_ALL_PACKAGE_COUNTRIES {
    allPackageCountries {
      code
      name
    }
  }
`;

export const CREATE_PACKAGE_ADDRESS = gql`
  mutation CreatePackageAddress(
    $shortName: String!
    $company: String
    $attention: String
    $email: String
    $phone: String!
    $streetAddress: String!
    $streetAddress2: String
    $cityPostal: String!
    $country: String!
    $countryName: String
  ) {
    createPackageAddress(
      shortName: $shortName
      company: $company
      attention: $attention
      email: $email
      phone: $phone
      streetAddress: $streetAddress
      streetAddress2: $streetAddress2
      cityPostal: $cityPostal
      country: $country
      countryName: $countryName
    ) {
      address {
        id
        shortName
        company
        attention
        email
        phone
        streetAddress
        streetAddress2
        cityPostal
        country
        countryName
      }
    }
  }
`;

export const UPDATE_PACKAGE_ADDRESS = gql`
  mutation UpdatePackageAddress(
    $id: ID!
    $shortName: String
    $company: String
    $attention: String
    $email: String
    $phone: String!
    $streetAddress: String
    $streetAddress2: String
    $cityPostal: String
    $country: String
    $countryName: String
  ) {
    updatePackageAddress(
      id: $id
      shortName: $shortName
      company: $company
      attention: $attention
      email: $email
      phone: $phone
      streetAddress: $streetAddress
      streetAddress2: $streetAddress2
      cityPostal: $cityPostal
      country: $country
      countryName: $countryName
    ) {
      address {
        id
        shortName
        company
        attention
        email
        phone
        streetAddress
        streetAddress2
        cityPostal
        country
        countryName
      }
    }
  }
`;

export const DELETE_PACKAGE_ADDRESS = gql`
  mutation DeletePackageAddress($id: ID!) {
    deletePackageAddress(id: $id) {
      success
    }
  }
`;
